module.exports = __webpack_public_path__ + "static/media/grid.0bd6c40b.svg";